import { debouncer, documentReady } from "../Utility/utils";
import Dom from "../Utility/Dom";
documentReady((event) => {
  // Play videos on play button
  document.addEventListener('click', function(e) {
    if (e.target.matches('a.video_block__trigger') || !!e.target.closest('a.video_block__trigger')) {
      e.preventDefault();

      const target = e.target.closest('.video_block');
      const trigger = target.querySelector('a.video_block__trigger');

      // Fade out trigger
      trigger.classList.add('fadeOut');
      setTimeout(function(){
        trigger.classList.add('hide');
      }, 300);

      // if the video is an iframe
      if(!!target.querySelector('iframe')){
        const iframe = target.querySelector('iframe');
        const src = iframe.getAttribute('src');
        const playSrc = src + '&autoplay=true';
        iframe.setAttribute('src', playSrc);
      } else {
        const video = target.querySelector('style-video');
        video.video.play();
      }
    }
  });
});

export function listenForMediaLoad(){
  document.querySelectorAll('.video_wrap').forEach((el)=>{
    const videos = el.querySelectorAll('video');
    const styleVideos = el.querySelectorAll('style-video');
    const iframes = el.querySelectorAll('iframe');
    const fallbacks = el.querySelectorAll('.fallback');
    if(fallbacks){
      fallbacks.forEach(el=>el.addEventListener('transitionend',(e)=>{
        if(Dom.prefersMotion){
          e.target.setAttribute('aria-hidden','true')
          e.target.style.display = 'none';
        }
      }))
    }
    if(videos.length){
      videos.forEach(video=>{
        if(Dom.prefersMotion){
          if(video.classList.contains('lazy')){
            
          }
          else {
            initVideos(video);
          }
        } else {
          video.pause();
        }
      })

    }
    if(styleVideos.length){
      styleVideos.forEach(styleVideo=>{
        if(styleVideo.video.readyState === 3){
          styleVideo.classList.add('loaded');
        }
        else{
          styleVideo.video.addEventListener('canplay', (e)=>{
            styleVideo.classList.add('loaded');
          });
        }
      })
    }
    if(iframes.length){
      iframes.forEach(iframe=>{
        iframe.addEventListener('load',()=> {
          iframe.classList.add('loaded');
        })
        if(iframe.classList.contains('autoplay') && Dom.prefersReducedMotion){
          const url = new URL(iframe.src);
          url.searchParams.delete('autoplay');
          iframe.src = url.href;
        }
      })
    }
  });
}

function initVideos(video){
  if(video.hasAttribute('autoplay')){
    video.play()
  }
  if(video.readyState === 3){
    video.classList.add('loaded');
  }
  else{
    video.addEventListener('canplay', (e)=>{
      video.classList.add('loaded');
    });
  }
}